export var getSearch = function getSearch() {
  return window.location.search;
};
export var getHref = function getHref() {
  return window.location.href;
};